import {ApiConfig} from '../app/models/configs/api.config';

export const API_CONFIGS: ApiConfig = {
    apis: {
        internal: {
            path: 'internal'
        },
        bfa: {
            path: 'backend-for-app'
        },
        signalR: {
            path: 'amagnoeventservice/pushMessageEventHub'
        },
    },
    apiTimeoutsInMs: {
        serverInformation: 10000,
        stampDocument: 30000,
        waitForDocumentToBeReady: 30000
    },
    maxDocumentFetchCount: 255,
    maxTagValueLength: 255,
    defaultDocumentLockTimeInMs: 480000,
    documentLockRefreshBufferTimeInMs: 30000,
    paths: {
        icons: 'icons',
        serverInformation: 'server-information',
        userIcons: '/users/{userId}/icon',
        vaultIcons: '/vaults/{vaultId}/icon',
    },
    requiredApiVersion: {
        major: 2,
        minor: 37
    }
};
